import { isUndefined } from '../utils/isUndefined.js';
import { isNonEmptyString } from '../utils/isNonEmptyString.js';
import { isNumber } from '../utils/isNumber.js';
import { base } from './base.js';

/**
 * Error
 * @url http://www.jsonrpc.org/specification#error_object
 * @constructor
 * @param {Number} code - A Number that indicates the error type that occurred
 * @param {String} message - A String providing a short description of the error
 * @param {*} [data] - A Primitive or Structured value that contains additional information about the error
 */
function JsonRpcError(code, message, data) {
    if (!(this instanceof JsonRpcError)) {
        // @ts-ignore
        return new JsonRpcError(code, message, data);
    }
    if (!isNumber(code)) {
        throw new TypeError('Error code must be a number');
    }
    if (!isNonEmptyString(message)) {
        throw new TypeError('Error message must be a non-empty string');
    }
    base(this);
    this.code = code;
    this.message = message;
    if (!isUndefined(data)) {
        this.data = data;
    }
}

export { JsonRpcError };
